import React, {useState, useEffect} from 'react';
import { Modal, Button, ModalHeader } from "react-bootstrap";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../../theme";


const Feedback: React.FC<{
    feedbackGreet: any;
    setFeedbackGreet: any;
  }> = ({feedbackGreet, setFeedbackGreet}) => {


    const theme = useTheme(); // Access the current theme
    const colors = tokens(theme.palette.mode);
    let color = theme.palette.mode;
    const handleClose = () => setFeedbackGreet(!feedbackGreet);

  
    useEffect(() => {
      // Set CSS variables based on the current theme colors
      document.documentElement.style.setProperty(
        "--header-bg-color",
        colors.headers.backround
      );
      document.documentElement.style.setProperty(
        "--header-text-color",
        colors.headers.text
      );
      document.documentElement.style.setProperty(
        "--box-shadow",
        colors.headers.boxShadow
      );
    }, [theme]);
  
    return (
      <>
        <Modal
          show = {feedbackGreet}
          onHide={handleClose}
          data-bs-theme={color}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          // style={{padding: '0px !important'}}
        >


          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
          </Modal.Header>
          
          <Modal.Body style={{ margin: 0 }}>

            <h5
                style={{
                  color: "var(--header-text-color)",
                  marginBottom: "12px",
                  textAlign:'center',
                }}
              >
                Thank You For Your Feedback!
              </h5>
            
          </Modal.Body>

        </Modal>
      </>
    );
  };

  export default Feedback;
  